<template>
  <div class="row justify-content-center">
    <div class="col-md-12 col-lg-6 col-xl-3 mt-5">
      <card class="text-center  h-100">
        <h3 class="card-title">PODEŠAVANJA</h3>
        <div class="row justify-content-center">
          <div class="col-11 col-md-10 col-lg-10 col-xl-10 card-body-mid" style="font-size:20px;">
            <p style="margin-top:35px;">
              Model:
              <b>{{model}}</b>
            </p>
            <p>
              Garancija:
              <b>{{warranty}}</b>
            </p>
          </div>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
  export default {
  }
</script>
<style>
</style>
